// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YiAxlty_jTgpgQKcerbm{height:100%;margin-bottom:16px;position:relative}.kFWd18cBVEoacpdH_Ied{flex-direction:column;height:100%;display:flex;overflow-x:scroll}.jItkj46733E1TLf6Nmz_{flex-direction:column;flex-grow:1;width:100%;margin:0 auto;display:flex}@media (max-width:992px){.jItkj46733E1TLf6Nmz_{width:620px}}@media (min-width:992px){.jItkj46733E1TLf6Nmz_{width:624px}}@media (min-width:1200px){.jItkj46733E1TLf6Nmz_{width:760px}}@media (min-width:1440px){.jItkj46733E1TLf6Nmz_{width:760px}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `YiAxlty_jTgpgQKcerbm`,
	"container": `kFWd18cBVEoacpdH_Ied`,
	"content": `jItkj46733E1TLf6Nmz_`
};
export default ___CSS_LOADER_EXPORT___;
